<template>
  <div
    v-if="realIntentions.length > 0"
    ref="scrollTable"
    class="pega-scroll-table"
    @scroll="onScroll"
  >
    <table class="unstriped hover boss-table">
      <thead>
        <tr data-test="table-head">
          <th
            data-test="registration"
            class="boss-table-head-center"
          >
            登録内容
          </th>
          <th
            data-test="registration-date"
            class="boss-table-head-center"
          >
            登録日
          </th>
          <th
            data-test="update-date"
            class="boss-table-head-center boss-update"
          >
            更新日
          </th>
          <th
            data-test="update"
            class="boss-table-head-center boss-operation"
          >
            編集
          </th>
          <th
            data-test="delete"
            class="boss-table-head-center boss-operation"
          >
            削除
          </th>
          <th
            data-test="preview"
            class="boss-table-head-center boss-operation"
          >
            プレビュー
          </th>
          <th class="boss-table-head-center boss-display-change">
            <div
              data-test="isPublished"
              class="pega-relative"
            >
              公開/非公開
              <span
                v-tooltip="{ content: '公開すると、会員サイトに掲載されます。'}"
                class="pega-circle small-right-top"
              >?</span>
            </div>
          </th>
        </tr>
      </thead>
      <real-intention-outline
        v-for="realIntention in realIntentions"
        :key="realIntention.id"
        :real-intention="realIntention"
        @updated="updateObjects"
        @update-display="updateDisplay"
      />
    </table>
  </div>
  <div
    v-else
    class="grid-x grid-margin-y align-center margin-top-2"
  >
    <span
      data-test="no-data"
      class="cell medium-4 subheader"
    >評判が登録されていません。</span>
  </div>
</template>

<script>
import RealIntentionOutline from '@/components/molecules/RealIntentionOutline'
import { hideAllPoppers } from 'floating-vue'

export default {
  components: {
    RealIntentionOutline
  },
  props: {
    realIntentions: {
      type: Array,
      required: true
    }
  },
  methods: {
    onScroll () {
      hideAllPoppers()
    },
    updateObjects () {
      this.$emit('fetch')
    },
    updateDisplay (data) {
      const index = this.realIntentions.findIndex(realIntention => realIntention.id === data.id)
      this.$set(this.realIntentions, index, data)
      this.$emit('update-display')
    }
  }
}
</script>
